<div class="main-container-mid-side favorites">
  <div class="container">
    <div class="header">
      <div class="header-text">
        <div class="left">
          <image-loader-utils [url]="this.sportsSvgList[this.liveMatchList.SportId]?.svgKey" extraClasses="sportmenusvg"></image-loader-utils>
        </div>
        {{ this.liveMatchList.SportName }}
      </div>
    </div>
    <div *ngIf="this.oddComboSelected?.length > 0" class="odd-header">
      <div class="odd-combo-row">
        <ng-container *ngFor="let selectionItem of this.sportOddType.oddLiveMarketing; let indexMatch = index; trackBy: sportLiveTrackById">
          <div *ngIf="this._UiHelper.responsiveResolution && getResponsiveOddShow(indexMatch)" class="combo-box">
            <select [ngModel]="this.oddComboSelectedMarketing[indexMatch]" (ngModelChange)="this.changeOddLiveMarketingAction($event, indexMatch)">
              <option *ngFor="let odd of this.sportOddType.oddComboList" [ngValue]="odd">
                {{ odd.OddNameLong | translate }}
                <ng-container *ngIf="odd.OddNameLong2 !== ''">
                  {{ odd.OddNameLong2 | translate }}
                </ng-container>
              </option>
            </select>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="odd-header mobile" *ngIf="this.oddComboSelected?.length > 0">
      <div class="odd-box-row">
        <div
          class="odd-box"
          *ngFor="let odd of this.sportOddType.oddComboList; let comboIndex = index"
          [ngClass]="{ active: this.oddComboSelectedMarketing[0].OddId == odd.OddId }"
          (click)="this.changeOddLiveMarketingAction(odd, 0)">
          {{ odd.OddName | translate }}
        </div>
      </div>

      <div class="odd-combo-row title-row">
        <ng-container *ngFor="let oddCombo of this.oddComboSelectedMarketing; let comboIndex = index">
          <div class="combo-box-title">
            <div class="odd-title" *ngFor="let odd of this.sportOddType.oddComboList[comboIndex].OddTitles">
              {{ odd }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <livematch-component
      [oddLiveMarketingValue]="this.oddComboSelected"
      [isInitialized]="true"
      [_selectedOdds]="this._selectedOdds"
      [liveDataLength]="this.liveMatchList.matchList ? this.liveMatchList.matchList.length : 0"
      [__ResultLiveData]="this.__ResultLiveData"
      [isFavSection]="false"
      [sportSliderChanges]="this.liveMatchList.SportId"
      [isLoadMore]="false"></livematch-component>
  </div>
</div>
